import {diContainer} from './di-container';

/**
 * Inject dependency by string type alias.
 *
 * @param alias string type alias
 * @return the requested entity from the Dependency Injection container. If such an entity is not registered in the
 *   Dependency Injection container (yet),
 *   `undefined` will be returned.
 */
export function inject<T extends object>(alias: string): T;

/**
 * Inject dependency by type (constructor function).
 *
 * @param type type (constructor function).
 * @return the requested entity from the Dependency Injection container. If such an entity is not registered in the
 *   Dependency Injection container (yet),
 *   `undefined` will be returned.
 */
export function inject<T extends object>(type: new (...args: any[]) => T): T;

/**
 * Inject dependency by type (constructor function) or string type alias.
 *
 * @param typeOrAlias type (constructor function) or string type alias.
 * @return the requested entity from the Dependency Injection container. If such an entity is not registered in the
 *   Dependency Injection container (yet),
 *   `undefined` will be returned.
 */
export function inject<T extends object>(typeOrAlias: string | (new (...args: any[]) => T)): T;

/**
 * Inject dependency by type (constructor function) or string type alias.
 *
 * @param typeOrAlias type (constructor function) or string type alias.
 * @return the requested entity from the Dependency Injection container. If such an entity is not registered in the
 *   Dependency Injection container (yet),
 *   `undefined` will be returned.
 */
export function inject<T extends object>(typeOrAlias: string | (new (...args: any[]) => T)): T {
  if (!typeOrAlias) {
    throw new Error(
      `[Dependency Injection] you should pass type (constructor function) or string type alias to "inject(typeOrAlias)" function`,
    );
  }

  return diContainer.get<T>(typeOrAlias);
}

window.inject = inject;

declare global {
  interface Window {
    inject: typeof inject;
  }
  // @ts-expect-error TS2502: inject is referenced directly or indirectly in its own type annotation.
  const inject: typeof inject;
}
